<!--
 * @Author: Hwc
 * @LastEditors: Hwc
 * @Description: 
-->
<template>
  <section class="udp-list-title__container">
    <section class="left-container">
      <div class="title-container">
        <span class="title">{{ title }}</span>
      </div>
      <!-- 左侧插槽 -->
      <div class="left-slot-container">
        <slot name="left" />
      </div>
    </section>
    <section class="right-container">
      <!-- 右侧插槽 -->
      <slot name="right" />
    </section>
  </section>
</template>
<script>
export default {
  name: 'UdpListTitle',
  components: {},
  props: {
    title: {
      type: String,
      default: '默认标题',
    },
  },
  data() {
    return {
      input: '',
    };
  },
  created() {
    // preset
  },
  mounted() {
    // preset
  },
  methods: {},
};
</script>

<style lang='scss' scoped>
@import '@/styles/variables.scss';
.udp-list-title__container {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  align-items: center;
  .left-container {
    display: flex;
    align-items: center;
    .title-container {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        top: 1px;
        left: 0;
        width: 4px;
        height: 16px;
        background-color: var(--primary-color);
      }
      .title {
        margin: 0 0 0 16px;
        font-weight: 600;
        font-size: $fontSize16;
        color: var(--text-color-1);
      }
    }
    .left-slot-container {
      display: inline-block;
    }
  }
}
</style>